import React from 'react';
import {Helmet} from 'react-helmet';
import PropTypes from "prop-types";

const DEFAULT_TITLE = 'Mentra';
const DEFAULT_DESCRIPTION = 'Accessible online therapy for depression and anxiety. Get therapy online with licensed professionals. Free online therapy sessions, counseling for anxiety and depression, and evidence-based mental health treatment.';
const DEFAULT_KEYWORDS = 'online therapy for depression, therapy for anxiety and depression, online therapy for depression and anxiety, get therapy online, online counseling for anxiety and depression, therapy for stress and depression, online therapy sessions for depression, therapy for depression, therapy for anxiety, counseling therapy for depression, clinical depression therapies, treatment for mental depression, natural treatment for depression, outpatient therapy for depression, group therapy for depression, best therapy for depression, free online therapy for depression, free online therapy sessions for depression, therapy for teenage depression, types of therapy for anxiety and depression, holistic treatment for anxiety and depression, mental health treatment, mental health, wellbeing, emotional support';
const DEFAULT_OG_IMAGE = 'https://yourmentra.com/assets/logov2-839tCyk0.svg';
const DEFAULT_OG_URL = 'https://yourmentra.com/';

function Title({
    title = DEFAULT_TITLE,
    description = DEFAULT_DESCRIPTION,
    keywords = DEFAULT_KEYWORDS,
    ogTitle,
    ogDescription,
    ogImage = DEFAULT_OG_IMAGE,
    ogUrl = DEFAULT_OG_URL,
    twitterCard,
    canonicalUrl,
    fullTitle,
}) {
    const baseUrl = 'https://yourmentra.com';
    const currentUrl = canonicalUrl || ogUrl || (typeof window !== 'undefined' ? `${baseUrl}${window.location.pathname}` : baseUrl);
    
    // Use fullTitle if provided, otherwise use title with "- Mentra" suffix
    const pageTitle = fullTitle || `${title} - Mentra`;
    
    return (
        <Helmet>
            {/* Default Meta Tags */}
            <title>{pageTitle}</title>
            <meta name="description" content={description}/>
            <meta name="keywords" content={keywords}/>
            <link rel="canonical" href={currentUrl}/>

            {/* Open Graph Meta Tags */}
            <meta property="og:title" content={ogTitle || title}/>
            <meta property="og:type" content="website"/>
            <meta property="og:description" content={ogDescription || description}/>
            <meta property="og:image" content={ogImage}/>
            <meta property="og:url" content={ogUrl || currentUrl}/>
            <meta property="og:site_name" content="Mentra"/>

            {/* Twitter Meta Tags */}
            <meta name="twitter:card" content={twitterCard || 'summary_large_image'}/>
            <meta name="twitter:title" content={ogTitle || title}/>
            <meta name="twitter:description" content={ogDescription || description}/>
            <meta name="twitter:image" content={ogImage}/>
        </Helmet>
    );
}


Title.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    keywords: PropTypes.string,
    ogTitle: PropTypes.string,
    ogDescription: PropTypes.string,
    ogImage: PropTypes.string,
    ogUrl: PropTypes.string,
    twitterCard: PropTypes.string,
    canonicalUrl: PropTypes.string,
    fullTitle: PropTypes.string,
}

export default Title;
